import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full h-full gap-4 py-5" }
const _hoisted_2 = { class: "absolute top-0 right-0 z-10 flex items-center w-8 h-full" }

import { useRoute, useRouter } from 'vue-router';
import { computed, onMounted, PropType, ref, Ref, watch } from 'vue';

import { useGetDeviceQuery } from '@/entities/device/hooks';
import { useGetInspectionQuery, useGetInspectionsQuery } from '@/entities/inspection/hooks';

import { Inspection } from '@/entities/inspection/types';

import { NkButton, NkGroup, NkStack, NkInlineModal } from '@/core/components';
import VoldateMeasureCreateForm
  from '@/entities/volta-measure/components/form/VoltaMeasureCreateForm.vue';
import VoltaMeasuresTable from '@/entities/volta-measure/components/VoltaMeasureTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VoltaWorkspace',
  props: {
  inspectionId: {
    type: Number as PropType<Inspection['id']>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const route = useRoute();
const router = useRouter();



const controlsVolta = [
  {
    name: 'Global',
    value: 6,
    icon: 'NkReceipt',
    access: 'all',
  },
  {
    name: 'Inline',
    value: 2,
    icon: 'NkViewSidebar',
    access: 'all',
  }
];

const activeControlValue = ref(2);

// Fetching inspection
const inspectionQueryData = computed(() => ({ id: props.inspectionId }));
const hasInspectionQueryData = computed(() => !!inspectionQueryData.value.id);
const { data: inspection } = useGetInspectionQuery(inspectionQueryData, {
  enabled: hasInspectionQueryData,
});

// Fetching device
const deviceQueryData: Ref = computed(() => ({ id: inspection.value?.device }));
const hasDeviceQueryData = computed(() => !!deviceQueryData.value.id);
const { data: device } = useGetDeviceQuery(deviceQueryData, {
  enabled: hasDeviceQueryData,
});

const isBladeElement = computed(() => (device.value?.type !== 23));

// Fetching inspectionGroup
const inspectionGroupQueryData: Ref = computed(() => ({
  id: inspection.value?.inspectionGroup,
}));

const hasInspectionGroupQueryData = computed(() => !!inspectionGroupQueryData.value.id);
const test = computed(() => ({ inspectionGroup: inspection.value?.inspectionGroup }))
const { data: allInspections } = useGetInspectionsQuery({ enabled:  hasInspectionGroupQueryData}, test)

// console.log(allInspections)

const allAnnotationsVolta = computed(() => {
  const _ = allInspections.value?.filter(e => e.voltaMeasures.length !== 0)
  if (_?.length === 0) {
    return []
  }
  return _.map(e => e.voltaMeasures).reduce((e1, e2) => e1.concat(e2))
})

// Fetching for VoltaMeasures
const voltaMeasuresIds = computed(() => inspection.value?.voltaMeasures || []);

// const getTableColumnFilters = computed(() => activeControlValue.value === 1 || activeControlValue.value === 6 ? [] : ['problem-type', 'severity']);

const switchView = async (value: number) => {
  await router.push({
    ...route,
    query: {
      ...(route.query || {}),
      view: value,
    },
  });
  activeControlValue.value = value
}

watch(() => route.query.view, () => {
  activeControlValue.value = Number(route.query.view);
})

onMounted(() => {
  if (route.query?.view) {
    activeControlValue.value = Number(route.query.view);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
    '!pl-4': activeControlValue.value !== 1,
      }, "relative h-full pl-8 pr-8"])
  }, [
    _createVNode(_unref(NkStack), {
      class: _normalizeClass([{
            'py-5': activeControlValue.value === 1,
          }, "h-full"]),
      spacing: 6
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NkGroup), {
          class: "flex-1 min-h-0 bg-white",
          spacing: 4,
          "no-wrap": "",
          align: "flex-start"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.$store.getters['connection/isGranted'](['volta_measure_create']))
                ? (_openBlock(), _createBlock(_unref(NkGroup), {
                    key: 0,
                    position: "right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NkInlineModal), {
                        title: _ctx.$t('volta-measure.action.add'),
                        class: "max-w-screen-md"
                      }, {
                        content: _withCtx(({close}) => [
                          _createVNode(VoldateMeasureCreateForm, {
                            "is-blade-element": _unref(isBladeElement),
                            onSubmitted: close
                          }, null, 8, ["is-blade-element", "onSubmitted"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(NkButton), { icon: "NkPlus" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('volta-measure.action.add')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["title"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(VoltaMeasuresTable, {
                "measures-ids": activeControlValue.value === 6 ? _unref(allAnnotationsVolta) : _unref(voltaMeasuresIds)
              }, null, 8, ["measures-ids"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NkStack), {
        justify: "center",
        align: "center",
        class: "w-full py-5",
        spacing: 4
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(controlsVolta, (control) => {
            return _createElementVNode("div", {
              key: control.value
            }, [
              (control.access === 'all' || control.access ==='admin' && _ctx.$store.getters['connection/isGranted'](['ROLE_ADMIN']))
                ? (_openBlock(), _createBlock(_unref(NkButton), {
                    key: 0,
                    onClick: ($event: any) => (switchView(control.value)),
                    icon: control.icon,
                    plain: activeControlValue.value === control.value,
                    circle: "",
                    size: "sm"
                  }, null, 8, ["onClick", "icon", "plain"]))
                : _createCommentVNode("", true)
            ])
          }), 64))
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})